import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";
import Grid from "@material-ui/core/Grid";
import { grey } from "@mui/material/colors";
import { Checkbox } from "@mui/material";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";

import { MsalContext } from "@azure/msal-react";

//Import styles
import "./DashboardUserRoll.scss";

//Import components
import fetchAPI from "../../../../components/utils/fetchAPI";
import DialogHoneyLoad from "../../Components/DialogHoneyLoad/DialogHoneyLoad";

import runtimeEnv from "@mars/heroku-js-runtime-env";

const env = runtimeEnv();
export default class DashboardLoader extends Component {
  static contextType = MsalContext;
  state = {
    tableColumns: ["Usuarios", "Administrador", "Editor", "Lector"],
    rowsUser: [],
    rows: [],
    labelDropdown: "Guardar Cambios",
    dropdownOptions: "",
    dialogOpen: false,
    dialogSectionFile: true,
    dialogLoadingFile: false,
    currentFile: undefined,
    fileProgress: 0,
    responseFileProgress: "",
    responseCompletedSKU: false,
    responseCompletedClient: false,
    dropzone: undefined,
    selectedType: "",
    availableCountries: [],
    selectedCountryCode: "",
    userId: "",
    page: 0,
    rowsPerPage: 20,
    checkedRoll: [],
    checkedAdmin: true,
    checkedEdit: false,
    checkedView: false,
    templateDialog: null,
  };

  componentDidMount() {
    const userCountry = window.sessionStorage.getItem(
      "maz_abi_digitalsalesportal_front_copec_user_country"
    );
    const userCountryCode = window.sessionStorage.getItem(
      "maz_abi_digitalsalesportal_front_copec_user_country_code"
    );
    this.handleCountryUpdate(userCountry, userCountryCode);
    const userID = document.getElementById("exclution-data-user-id").value;
    this.setState({
      userId: userID !== "" ? userID : "undefinedUser",
    });
  }

  openDialog = ({
    message,
    showIcon,
    iconType,
    buttonCancel,
    buttonAccept,
    onClickCancel,
    onClickAccept,
  }) => {
    this.setState({
      templateDialog: null,
    });
    const templateDialog = (
      <DialogHoneyLoad
        opened={true}
        showIcon={showIcon}
        iconType={iconType}
        message={message}
        buttonCancel={buttonCancel}
        buttonAccept={buttonAccept}
        onClickCancel={onClickCancel}
        onClickAccept={onClickAccept}
      />
    );
    this.setState({
      templateDialog: templateDialog,
    });
  };

  fetchLoader = async ({ country }) => {
    this.setState({
      rowsUser: [],
    });

    const selectedCountryCode =
      typeof country !== "undefined" ? country : this.state.selectedCountryCode;
    const servicesUsers = env.REACT_APP_SERVICES_GET_ALL_USERS;

    if (selectedCountryCode !== "0") {
      fetchAPI({
        protocol: "GET",
        service: servicesUsers + "/" + this.props.countriesCode,
        params: {
          codeCountry: this.props.countriesCode,
        },
        callbackThen: (response) => {
          const arr = [];
          var arr2 = [];

          for (var rows in response) {
            const row = response[rows];
            row.type = "Users";
            arr.push(row);
          }
          arr[0].map((element, index) => {
            return element.clientPermission === "Editor"
              ? this.setState({ checkedEdit: !this.state.checkedEdit })
              : element.clientPermission === "Administrador"
              ? this.setState({ checkedAdmin: !this.state.checkedAdmin })
              : this.setState({ checkedView: !this.state.checkedView });
          });
          arr[0].map((element, index) => {
            return (arr2[index] = element.clientPermission);
          });
          this.setState({
            rowsUser: arr,
            rowsChecked: arr2,
          });
        },
      });
    }
  };

  toggleDialogOpen() {
    this.setState({
      dialogOpen: !this.state.dialogOpen,
      dialogSectionFile: true,
    });
  }

  handleDialogCombo = (eventKey, event) => {
    const selectedFileType = event.target.innerHTML;
    this.setState({
      selectedType: selectedFileType,
    });
    this.toggleDialogOpen();
  };

  handleDialogClose = () => {
    this.toggleDialogOpen();
    this.setState({
      loaderFiles: [],
    });
  };

  handleDropdown = (selectedValue, evt) => {
    this.setState({
      selectedCountry: evt.target.outerText,
      selectedCountryCode: selectedValue,
    });

    this.fetchLoader({
      country: selectedValue,
    });
  };

  handleCountryUpdate = (countryName, countryCode) => {
    this.setState({
      selectedCountry: countryName,
      selectedCountryCode: countryCode,
    });

    this.fetchLoader({
      country: countryCode,
    });
  };

  handleLoadingFileCloseButton = () => {
    this.toggleDialogOpen();
    this.setState({
      dialogSectionFile: true,
      dialogLoadingFile: false,
      esponseFileProgress: "",
      fileProgress: 0,
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: +event.target.value,
      page: 0,
    });
  };

  handleChangeChakedBoxEdit = (e) => {
    this.setState({
      checkedEdit: e.target ? e.target.checked : this.state.checkedEdit,
    });
  };

  handleChangeCheckboxAdm = (id) => (event) => {
    var rowsAdm = this.state.rowsChecked;
    rowsAdm[id] = "Administrador";
    this.setState({
      rowsChecked: rowsAdm,
    });
  };

  handleChangeCheckboxEditor = (id) => (event) => {
    var rowsEdt = this.state.rowsChecked;
    rowsEdt[id] = "Editor";
    this.setState({
      rowsChecked: rowsEdt,
    });
  };

  handleChangeCheckboxReader = (id) => (event) => {
    var rowsRead = this.state.rowsChecked;
    rowsRead[id] = "Lector";
    this.setState({
      rowsChecked: rowsRead,
    });
  };

  handleChangeChakedBoxAdm = (e) => {
    this.setState({
      checkedAdmin: e.target ? e.target.checked : this.state.checkedAdmin,
    });
  };
  handleChangeChakedBoxView = (e, ident) => {
    this.setState({
      checkedView: ident !== "undefined" ? ident : this.state.checkedView,
    });
  };

  handleUpdateRoll = (codeCountry) => {
    const servicesUsers =
      env.REACT_APP_SERVICES_PATCH_MULTIROLL + `/${this.props.countriesCode}`;

    this.openDialog({
      message: "Guardando configuración",
      iconType: "updating",
      showIcon: true,
      buttonAccept: false,
    });
    var arr = this.state.rowsUser;
    var arr2 = [];
    arr[0].map((element, index) => {
      return arr2.push({
        clientId: element.clientId,
        clientPermission: this.state.rowsChecked[index],
      });
    });

    const payload = { accounts: arr2 };
    fetchAPI({
      service: `${servicesUsers}`,
      protocol: "PATCH",
      params: payload,
      codeCountry: this.props.countriesCode,
      callbackThen: (response) => {
        try {
          this.openDialog({
            message: "Los cambios fueron guardados con éxito",
            iconType: "success",
            showIcon: true,
            onClickAccept: () => {
              //this.props.emptyExclutions();
              this.setState({
                templateDialog: null,
              });
            },
          });
        } catch (e) {
          console.log(e);
        }
      },
      callbackError: (err) => {
        console.log(err);
      },
    });
  };

  selectPage = (e) => {
    const page = e.target.dataset.page;
    const pageNumber = parseInt(page) - 1;
    this.setState({
      page: pageNumber,
    });
  };

  previousPage = () => {
    if (this.state.page > 0) {
      this.setState({
        page: this.state.page - 1,
      });
    }
  };
  nextPage = () => {
    const totalRows = this.state.rowsSKU.concat(
      this.state.rowsExclutions,
      this.state.rowsPromotions
    );
    const pageCount = Math.ceil(totalRows.length / this.state.rowsPerPage);
    if (this.state.page < pageCount - 1) {
      this.setState({
        page: this.state.page + 1,
      });
    }
  };

  render() {
    const StyledTableCell = withStyles((theme) => ({
      head: {
        backgroundColor: theme.palette.common.black,
        color: "#FFFF00",
        fontFamily: "Roboto",
        fontstyle: "normal",
        fontWeight: "normal",
        fontSize: 18,
        padding: "8px 30px",
      },
      body: {
        fontSize: 14,
        padding: "9px 30px",
        maxHeight: "555px",
      },
    }))(TableCell);

    const StyledTableRow = withStyles((theme) => ({
      root: {
        "&:nth-of-type(odd)": {
          backgroundColor: theme.palette.action.hover,
        },
      },
    }))(TableRow);

    const totalRows = this.state.rowsUser;
    totalRows.sort(function (a, b) {
      return new Date(b.created_at) - new Date(a.created_at);
    });

    const pageCount = Math.ceil(totalRows.length / this.state.rowsPerPage);
    let pages = [];

    for (let i = 1; i <= pageCount; i++) {
      pages.push(i);
    }

    return (
      <div className="loader">
        <Grid container item xs={12} justifyContent="center">
          <Grid container item xs={12}>
            <Grid
              item
              container
              xs={6}
              spacing={0.5}
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={6}>
                <div className="loader__rollEditorInfo"></div>
              </Grid>
              <Grid item xs={6}>
                <div style={{ textAlign: "justify" }}>
                  <h7>
                    El Editor puede configurar, cargar exclusiones de tipo carga
                    masiva y por atributo. Además puede visualizar todas las
                    exclusiones que se hayan creado, así como descargar las
                    exclusiones generadas.
                  </h7>
                </div>
              </Grid>
            </Grid>
            <Grid item container xs={6} spacing={0.5}>
              <Grid item xs={6}>
                <div className="loader__rollLectorInfo"></div>
              </Grid>
              <Grid item xs={6}>
                <div style={{ textAlign: "justify" }}>
                  <h7>
                    El Lector solo puede visualizar las exclusiones que se han
                    generado, así como descargar los archivos de dichas
                    exclusiones en .csv
                  </h7>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div className="loader__table">
          <TableContainer
            component={Paper}
            classes={{ container: { maxHeight: 400 } }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {this.state.tableColumns.map((element, key) => (
                    <StyledTableCell align="left" key={key}>
                      {element}{" "}
                      {element === "Tipo de Carga" || element === "Estatus" ? (
                        <img
                          style={{ marginLeft: "2rem" }}
                          src="assets/filter/filter.png"
                          alt=""
                        />
                      ) : null}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {totalRows.length > 0 ? (
                  totalRows[0].map((row, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell align="left">
                        {row.clientName}
                        {<span class="loader__email"> {row.clientEmail}</span>}
                      </StyledTableCell>

                      {/*administrador*/}
                      <StyledTableCell align="left">
                        {this.state.rowsChecked[index] === "Administrador" ? (
                          <Checkbox
                            onChange={this.handleChangeCheckboxAdm(index)}
                            sx={{
                              "& .MuiSvgIcon-root": { fontSize: 22 },
                              color: grey[900],
                              "&.Mui-checked": { color: grey[900] },
                            }}
                            checked={true}
                          />
                        ) : this.state.rowsChecked[index] === "Editor" ? (
                          <Checkbox
                            onChange={this.handleChangeCheckboxAdm(index)}
                            sx={{
                              "& .MuiSvgIcon-root": { fontSize: 22 },
                              color: grey[900],
                              "&.Mui-checked": { color: grey[900] },
                            }}
                          />
                        ) : this.state.rowsChecked[index] === "Lector" ? (
                          <Checkbox
                            onChange={this.handleChangeCheckboxAdm(index)}
                            sx={{
                              "& .MuiSvgIcon-root": { fontSize: 22 },
                              color: grey[900],
                              "&.Mui-checked": { color: grey[900] },
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </StyledTableCell>
                      {/*editor*/}
                      <StyledTableCell align="left">
                        {this.state.rowsChecked[index] === "Administrador" ? (
                          <Checkbox
                            onChange={this.handleChangeCheckboxEditor(index)}
                            sx={{
                              "& .MuiSvgIcon-root": { fontSize: 22 },
                              color: grey[900],
                              "&.Mui-checked": { color: grey[900] },
                            }}
                          />
                        ) : this.state.rowsChecked[index] === "Editor" ? (
                          <Checkbox
                            onChange={this.handleChangeCheckboxEditor(index)}
                            sx={{
                              "& .MuiSvgIcon-root": { fontSize: 22 },
                              color: grey[900],
                              "&.Mui-checked": { color: grey[900] },
                            }}
                            checked={true}
                          />
                        ) : this.state.rowsChecked[index] === "Lector" ? (
                          <Checkbox
                            onChange={this.handleChangeCheckboxEditor(index)}
                            sx={{
                              "& .MuiSvgIcon-root": { fontSize: 22 },
                              color: grey[900],
                              "&.Mui-checked": { color: grey[900] },
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </StyledTableCell>
                      {/*lector*/}
                      <StyledTableCell align="left">
                        {this.state.rowsChecked[index] === "Administrador" ? (
                          <Checkbox
                            onChange={this.handleChangeCheckboxReader(index)}
                            sx={{
                              "& .MuiSvgIcon-root": { fontSize: 22 },
                              color: grey[900],
                              "&.Mui-checked": { color: grey[900] },
                            }}
                          />
                        ) : this.state.rowsChecked[index] === "Lector" ? (
                          <Checkbox
                            onChange={this.handleChangeCheckboxReader(index)}
                            sx={{
                              "& .MuiSvgIcon-root": { fontSize: 22 },
                              color: grey[900],
                              "&.Mui-checked": { color: grey[900] },
                            }}
                            checked={true}
                          />
                        ) : (
                          <Checkbox
                            onChange={this.handleChangeCheckboxReader(index)}
                            sx={{
                              "& .MuiSvgIcon-root": { fontSize: 22 },
                              color: grey[900],
                              "&.Mui-checked": { color: grey[900] },
                            }}
                          />
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell align="left">
                      <Skeleton />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Skeleton />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Skeleton />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Skeleton />
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <div className="loader__actions">
          <div className="loader__pager">
            {pages.length === 1 ? (
              ""
            ) : (
              <div className="loader__pager__container">
                <div
                  className="loader__pager__left"
                  onClick={this.previousPage}
                ></div>
                <div className="loader__pager__pages">
                  <ul>
                    {pages.map((value, index) => (
                      <li
                        className={
                          String(this.state.page) === String(index)
                            ? "selected"
                            : ""
                        }
                        data-page={value}
                        onClick={this.selectPage}
                      >
                        {value}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className="loader__pager__right"
                  onClick={this.nextPage}
                ></div>
              </div>
            )}
          </div>
          <Dropdown
            className="loader__dropdown yellowUserRoll"
            onClick={this.handleUpdateRoll}
          >
            <Dropdown.Toggle id="dropdown-basic">
              {this.state.labelDropdown}
            </Dropdown.Toggle>
          </Dropdown>
          {/* <DropdownButton
            className="loader__button yellow"
            onClick={this.handleUpdateRoll}
            title={this.state.labelDropdown}
          /> */}
        </div>
        {this.state.templateDialog}
      </div>
    );
  }
}
